export default __webpack_public_path__ + "static/media/Base_Rock.5cf14a2c.jpeg";